export default __webpack_public_path__ + "static/media/bektemir.c7c8fa52.jpg";